var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2604_1962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8354 18.5625L19.0208 15.4L18.0583 14.4375L15.8354 16.6146L14.9417 15.7208L13.9792 16.7063L15.8354 18.5625ZM5.5 8.25H16.5V6.41667H5.5V8.25ZM16.5 21.0833C15.2319 21.0833 14.1512 20.6363 13.2578 19.7423C12.3643 18.8482 11.9173 17.7674 11.9167 16.5C11.9167 15.2319 12.3637 14.1512 13.2578 13.2578C14.1518 12.3643 15.2326 11.9173 16.5 11.9167C17.7681 11.9167 18.8491 12.3637 19.7432 13.2578C20.6372 14.1518 21.0839 15.2326 21.0833 16.5C21.0833 17.7681 20.6363 18.8491 19.7423 19.7432C18.8482 20.6372 17.7674 21.0839 16.5 21.0833ZM2.75 20.1667V4.58333C2.75 4.07917 2.92967 3.64772 3.289 3.289C3.64833 2.93028 4.07978 2.75061 4.58333 2.75H17.4167C17.9208 2.75 18.3526 2.92967 18.7119 3.289C19.0713 3.64833 19.2506 4.07978 19.25 4.58333V10.7021C18.9597 10.5646 18.6618 10.45 18.3562 10.3583C18.0507 10.2667 17.7375 10.1979 17.4167 10.1521V4.58333H4.58333V17.4625H10.1521C10.2285 17.9361 10.347 18.3868 10.5078 18.8146C10.6685 19.2424 10.8784 19.6472 11.1375 20.0292L11 20.1667L9.625 18.7917L8.25 20.1667L6.875 18.7917L5.5 20.1667L4.125 18.7917L2.75 20.1667ZM5.5 15.5833H10.1521C10.1979 15.2625 10.2667 14.9493 10.3583 14.6438C10.45 14.3382 10.5646 14.0403 10.7021 13.75H5.5V15.5833ZM5.5 11.9167H12.0083C12.5889 11.3514 13.2651 10.9044 14.0369 10.5756C14.8088 10.2468 15.6298 10.0827 16.5 10.0833H5.5V11.9167Z",
    fill: "#2DACF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2604_1962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavele);
export default __webpack_public_path__ + "static/media/navele.1b7010435f0280ba586b90996c620262.svg";
export { ForwardRef as ReactComponent };